import { type ApiDatoCelda, type GridColumnFromApi } from '../types/TablaDefTypes';

export function transformDirtyChangesToApiFormat(dirtyCells: ApiDatoCelda[], colsConfig: GridColumnFromApi[]) {
  for (const celda of dirtyCells) {
    const { wdato, col_id } = celda;

    const { type: colType = undefined } = colsConfig.find((col) => col.tablas_def_col_id === col_id) ?? {};

    if (colType === undefined) {
      throw new Error(`No se van a guardar los datos. No se encontró configuración de columna para col_id: ${col_id}`);
    }

    if (colType === 'date') {
      if (wdato && /^\d{4}-\d{2}-\d{2}$/.test(wdato)) {
        const [yyyy, mm, dd] = wdato.split('-');
        celda.wdato = `${dd}${mm}${yyyy}`;

        continue;
      }

      celda.wdato = undefined;
    }

    if (colType === 'number') {
      celda.wdato = transformNumberCellToApiFormat(wdato ?? '');
    }
  }

  return dirtyCells;
}

export function transformNumberCellToApiFormat(value: string): string {
  if (value === undefined || value === null || value.trim() === '') {
    return '0';
  }

  if (!isNaN(Number(value))) {
    return parseFloat(value).toString();
  }

  const sanitizedString = value.replace(/[.]/g, '').replace(/[,]/, '.');

  return parseFloat(sanitizedString).toString();
}
